<div class="toggle-menu" [ngClass]="{ showMenu: clickEvent }">
  <div class="toggle-menu__content">
    <button type="button" class="toggle-menu__close" (click)="onCloseMenu()">
      <img src="/assets/icons/menu-close-button-black.png" alt="Botón cerrar" />
    </button>
    <div class="toggle-menu__links">
      <a (click)="onOpenPrivacyPolicy()">Política de Privacidad</a>
      <a (click)="onOpenTermsAndConditions()">Términos y condiciones</a>
      <a (click)="onOpenFAQs()">Preguntas frecuentes</a>
    </div>
  </div>
  <div class="toggle-menu__footer">
    <div class="toggle-menu__footer__copyright">
      <p>© 2022 {{ CONST.BBVA_PRODUCT_NAME }}, Derechos Reservados.</p>
    </div>
    <div class="toggle-menu__footer__isotype">
      <img src="/assets/img/logo/powerpay-white-isotype-logo.svg" alt="Isotipo de Powerpay" />
    </div>
  </div>
</div>
